import { render, staticRenderFns } from "./McMessageList.vue?vue&type=template&id=d4865200&scoped=true&"
import script from "./McMessageList.vue?vue&type=script&lang=js&"
export * from "./McMessageList.vue?vue&type=script&lang=js&"
import style0 from "./McMessageList.vue?vue&type=style&index=0&id=d4865200&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4865200",
  null
  
)

export default component.exports